(function () {
  const originalFetch = window.fetch;

  function getBadge(button) {
    let badge = button.querySelector("cart-count");

    if (!badge) {
      badge = document.createElement("cart-count");
      badge.className = "cart-count cart-count--absolute font-body-bolder";
      button.appendChild(badge);
    }

    return badge;
  }

function renderCartCount(count) {
  document.querySelectorAll("a.cart-drawer-button").forEach((button) => {
    let badge = button.querySelector("cart-count");

    if (!badge) {
      badge = document.createElement("cart-count");
      badge.className = "cart-count cart-count--absolute font-body-bolder";
      button.appendChild(badge);
    }

    badge.textContent = String(count);
    badge.setAttribute(
      "aria-label",
      `${count} ${count === 1 ? "elementas" : "elementai"}`
    );

    if (count > 0) {
      badge.hidden = false;
      badge.removeAttribute("hidden");
      badge.style.display = "";
    } else {
      badge.hidden = true;
      badge.setAttribute("hidden", "");
    }
  });
}

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url =
        typeof args[0] === "string" ? args[0] : args[0]?.url || "";

      if (/\/cart\.(js|json)(\?|$)/.test(url) && response.ok) {
        const cart = await response.clone().json();
        renderCartCount(cart.item_count);
      } else if (/(\/cart\/add(\.js)?|\/add\.js)(\?|$)/.test(url) && response.ok) {
        setTimeout(async () => {
          try {
            const cartResponse = await originalFetch("/cart.js", {
              credentials: "same-origin",
            });
            const cart = await cartResponse.json();
            renderCartCount(cart.item_count);
          } catch (e) {
            console.warn("cart refresh failed", e);
          }
        }, 200);
      }
    } catch (e) {
      console.warn("cart watcher failed", e);
    }

    return response;
  };

  // optional: sync once on initial page load too
  window.addEventListener("DOMContentLoaded", async () => {
    try {
      const res = await originalFetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();
      renderCartCount(cart.item_count);
    } catch (e) {
      console.warn("initial cart sync failed", e);
    }
  });
})();